import { FormCollapse } from "components/Form";
import React from "react";
import { SectionToggleState, useFieldValue, useSectionHelper } from "hooks";
import { Section } from "containers/Settings/RuleBooks/Rules/CustomRules/constants";
import { CriteriaForm } from "./CriteriaForm";
import { CriteriaHeader } from "./CriteriaHeader";

interface CriteriaSectionProps {
  // The type of field (if any) from the RuleSet, which must be present in the LivestockSale Export Schema
  parentInputPath: string | null;

  hasPrerequisiteRule: boolean;

  // The section helper to manage the collapse state
  sectionToggleState: SectionToggleState;
}

export function CriteriaSection(props: CriteriaSectionProps) {
  const { hasPrerequisiteRule, sectionToggleState, parentInputPath } = props;

  const { isOpen, onToggle } = useSectionHelper(
    sectionToggleState,
    Section.CRITERIA,
  );

  const ruleInputPath = useFieldValue("input_field.value");

  const header = (
    <CriteriaHeader
      parentInputPath={parentInputPath}
      ruleInputPath={ruleInputPath}
      hasPrerequisiteRule={hasPrerequisiteRule}
    />
  );

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour={isOpen ? "hideCriteria" : "showCriteria"}
    >
      <CriteriaForm
        parentInputPath={parentInputPath}
        hasPrerequisiteRule={hasPrerequisiteRule}
      />
    </FormCollapse>
  );
}
